import React from "react";
import { Label } from "semantic-ui-react";

export const ValidationError = ({ isValid, children }) => {
    return isValid ? null : <Label basic color='red' style={{border:'none', paddingLeft: '0' , fontWeight:'normal'}}>{children}</Label>
}